import { useState, useEffect, useCallback } from 'react';
import { fetchControlDiario } from '../services/controlDiario.services';

// Hook: datos crudos del mes para el reporte "Control diario de producción".
export const useControlDiario = ({ idLavanderia, dateRange, enabled = true }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!enabled || !idLavanderia || !dateRange) return;
    setLoading(true);
    setError(null);
    try {
      setData(await fetchControlDiario({ idLavanderia, dateRange }));
    } catch (e) {
      setError(e.message || 'Error al cargar el control diario de producción');
    } finally {
      setLoading(false);
    }
  }, [idLavanderia, dateRange, enabled]);

  useEffect(() => {
    load();
  }, [load]);

  return { data, loading, error, reload: load };
};
